import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; // Import RouterModule
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MaterialModule } from './material.module';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragdropfileComponent } from './components/dragdropfile/dragdropfile.component';
import { MiniActivityQueueComponent } from './components/mini-activity-queue/mini-activity-queue.component';
import { SearchComponent } from './components/search/search.component';
import { DropDownComponent } from './components/drop-down/drop-down.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { AssetpreviewComponent } from './components/assetpreview/assetpreview.component';
import { TabularDataComponent } from './components/tabular-data/tabular-data.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxLoadingModule } from 'ngx-loading';
import { ByteToMbPipe } from './pipes/bytetomb.pipe';
import { LoaderComponent } from './components/loader/loader.component';
import { DefaultImgDirective } from './directives/default-img.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { HasAnyPermissionDirective } from './directives/has-any-permission.directive';
import { MediaRendererComponent } from './components/media-renderer/media-renderer.component';
import { VideoUploadThumbnailComponent } from './components/video-upload-thumbnail/video-upload-thumbnail.component';
import { AudioUploadThumbnailComponent } from './components/audio-upload-thumbnail/audio-upload-thumbnail.component';
import { PaginationBarComponent } from './components/pagination-bar/pagination-bar.component';
import { SnackBarComponent } from './components/snack-bar/snack-bar.component';
import { BusinessUnitSelectorComponent } from './components/business-unit-selector/business-unit-selector.component';
import { ProviderBusinessUnitInlineSelectorComponent } from './components/provider-business-unit-inline-selector/provider-business-unit-inline-selector.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule, // Ensure RouterModule is imported
  ],
  declarations: [
    NavbarComponent,
    SidenavComponent,
    MiniActivityQueueComponent,
    SearchComponent,
    DragdropfileComponent,
    DropDownComponent,
    DialogComponent,
    AssetpreviewComponent,
    TabularDataComponent,
    LoaderComponent,
    ByteToMbPipe,
    DefaultImgDirective,
    HasPermissionDirective,
    HasAnyPermissionDirective,
    MediaRendererComponent,
    VideoUploadThumbnailComponent,
    AudioUploadThumbnailComponent,
    PaginationBarComponent,
    SnackBarComponent,
    BusinessUnitSelectorComponent,
    ProviderBusinessUnitInlineSelectorComponent,
  ],
  exports: [
    NavbarComponent,
    SidenavComponent,
    MiniActivityQueueComponent,
    SearchComponent,
    DragdropfileComponent,
    MaterialModule,
    FormsModule,
    DropDownComponent,
    DialogComponent,
    ReactiveFormsModule,
    AssetpreviewComponent,
    TabularDataComponent,
    LoaderComponent,
    [NgxSpinnerModule.forRoot()],
    [NgxLoadingModule.forRoot({})],
    DefaultImgDirective,
    HasPermissionDirective,
    HasAnyPermissionDirective,
    MediaRendererComponent,
    VideoUploadThumbnailComponent,
    AudioUploadThumbnailComponent,
    PaginationBarComponent,
    SnackBarComponent,
    BusinessUnitSelectorComponent,
    ProviderBusinessUnitInlineSelectorComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
      },
    },
  ],
})
export class SharedUiModule {}
